var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 12,
    viewBox: "0 0 22 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#777D81",
    fillRule: "evenodd",
    d: "M1.95 0h2S7.106 4 11 4s7.05-4 7.05-4h2c0 .857-4.052 6-9.05 6S1.95.857 1.95 0m-.136 7.6A1 1 0 1 1 .4 6.186l1.401-1.401a1 1 0 1 1 1.414 1.414zm4.745 2.713a1 1 0 1 1-1.841-.781l.774-1.824a1 1 0 1 1 1.841.781zm5.441.678a1 1 0 1 1-2 0V9.009a1 1 0 1 1 2 0zm5.273-1.437a1 1 0 1 1-1.854.75l-.742-1.837a1 1 0 1 1 1.854-.75zM21.6 6.186A1 1 0 1 1 20.186 7.6l-1.401-1.401a1 1 0 1 1 1.414-1.414z"
  })));
});
const SvgEyeShowOnIcon = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEyeShowOnIcon);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMiIgaGVpZ2h0PSIxMiIgdmlld0JveD0iMCAwIDIyIDEyIj4KICAgIDxwYXRoIGZpbGw9IiM3NzdEODEiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTEuOTUgMGgyUzcuMTA2IDQgMTEgNGMzLjg5NCAwIDcuMDUtNCA3LjA1LTRoMmMwIC44NTctNC4wNTIgNi05LjA1IDZDNi4wMDIgNiAxLjk1Ljg1NyAxLjk1IDB6bS0uMTM2IDcuNkExIDEgMCAxIDEgLjQgNi4xODZsMS40MDEtMS40MDFhMSAxIDAgMSAxIDEuNDE0IDEuNDE0TDEuODE1IDcuNnptNC43NDUgMi43MTNhMSAxIDAgMSAxLTEuODQxLS43ODFsLjc3NC0xLjgyNGExIDEgMCAxIDEgMS44NDEuNzgxbC0uNzc0IDEuODI0em01LjQ0MS42NzhhMSAxIDAgMSAxLTIgMFY5LjAwOWExIDEgMCAxIDEgMiAwdjEuOTgyem01LjI3My0xLjQzN2ExIDEgMCAxIDEtMS44NTQuNzVsLS43NDItMS44MzdhMSAxIDAgMSAxIDEuODU0LS43NWwuNzQyIDEuODM3ek0yMS42IDYuMTg2QTEgMSAwIDEgMSAyMC4xODYgNy42bC0xLjQwMS0xLjQwMWExIDEgMCAxIDEgMS40MTQtMS40MTRsMS40MDEgMS40eiIvPgo8L3N2Zz4K";